function normalizeId(value, field) {
  const id = Number(value);
  if (!Number.isInteger(id) || id <= 0) {
    throw new Error(`Invalid catalog ID: ${field}`);
  }
  return id;
}

export function resolveCatalogProduct(catalog, builderKey, materialKey, variantKey) {
  const product = catalog?.[builderKey]?.products?.[materialKey];
  if (!product) return null;

  const result = {
    id: normalizeId(product.productId, `${builderKey}.${materialKey}.productId`),
  };

  if (variantKey !== materialKey) {
    const canonicalVariantKey =
      variantKey?.endsWith(`-${materialKey}`)
        ? variantKey.slice(0, -(materialKey.length + 1))
        : variantKey;
    result.variationId = normalizeId(
      product.variations?.[canonicalVariantKey],
      `${builderKey}.${materialKey}.variations.${canonicalVariantKey}`,
    );
  }

  return result;
}
